module.exports = __webpack_public_path__ + "static/img/image2.6951edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instruction_images/image2.png
// module id = PK0/
// module chunks = 0